import { css } from '@emotion/react';

const makeNewsletterStyles = ({ theme }) => {
  return {
    newsletterTextContainer: css({
      maxWidth: 500,
      margin: '0 auto 15px auto',
      textAlign: 'center',
    }),
    newsletterFooterContainer: css({
      marginTop: 15,
    }),
    subscribeButtonContainer: css({
      height: 55,
    }),
    noThanksButton: css({
      color: theme.mvf.palette.text.primaryTextColor,
      marginTop: 10,
      textTransform: 'none',
      width: '100%',
      textDecoration: 'underline',
      '&:hover': {
        background: 'none',
      },
    }),
    heading: css({
      marginTop: 10,
      '& h6': {
        fontWeight: 900,
        textAlign: 'center',
        fontSize: 30,
        lineHeight: 1,
        fontFamily: 'Public Sans, Arial, sans-serif',
      },
    }),
    subheading: css({
      margin: '15px 0',
      '& p': {
        fontFamily: 'Public Sans, Arial, sans-serif',
      },
    }),
    brandLogo: css({
      maxWidth: 220,
      margin: '0 auto',
    }),
    brandImage: css({
      maxWidth: 250,
      maxHeight: 242,
      [theme.breakpoints.between('mobileSmall', 500)]: {
        maxWidth: 175,
        maxHeight: 170,
      },
    }),
  };
};

export default makeNewsletterStyles;
